import $ from 'jquery';
import { mountVueComponent } from '@/lib/mount-vue-component';
import ResourceList from '../../lib/components/ResourceList';
import store from '@/lib/store';
import Vue from 'vue';

export default function () {
	import('@/lib/components/User/ProfilePhoto.vue').then((profilePhoto) => {
		mountVueComponent('profile-photo', profilePhoto);
	});

	const leaderboardProgress = new Vue({
		el: '#leaderboard-progress',
		name: 'LeaderboardProgressApp',
		components: {
			'leaderboard-progress': ResourceList,
		},
		store,
	});
	$(document).one('pjax:end', () => {
		leaderboardProgress.$destroy();
	});
}
